import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicViewsComponent } from './public-views.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: PublicViewsComponent,

    children: [

      {
        path: 'login',
        loadChildren: './login/login.module#LoginModule'
      },
      {
        path: 'sign-up',
        loadChildren: './sign-up/sign-up.module#SignUpModule'
      }
     ]
  },
  // { path: '**', redirectTo: 'index' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class PublicViewsRoutes { }



// WEBPACK FOOTER //
// ./src/app/public-views/public-views.routes.ts